<template>
  <div class="security-settings-container text-start animate-fade-in">
    <h4 class="h5 fw-bold font-serif text-primary-color mb-4 pb-2 border-bottom">
      <icon icon="fa-solid fa-shield-halved" class="me-2" />
      Cài đặt bảo mật
    </h4>
    
    <div class="row g-3">
      <div class="col-md-12">
        <div class="custom-form-group d-flex align-items-center justify-content-between p-3 rounded" style="background-color: var(--bg-surface);">
          <div>
            <h6 class="mb-1 font-serif fw-bold">Xác thực 2 bước (OTP qua Email)</h6>
            <p class="text-muted fs-7 mb-0">Tăng cường bảo mật cho tài khoản của bạn bằng cách yêu cầu mã OTP gửi qua email mỗi lần đăng nhập.</p>
          </div>
          <div class="form-check form-switch fs-4 m-0">
            <input 
              class="form-check-input cursor-pointer" 
              type="checkbox" 
              role="switch" 
              v-model="is2faEnabled"
              @change="update2faSetting"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./security-settings.js"></script>
<style scoped src="./security-settings.css"></style>
